import { render, staticRenderFns } from "./CreateSingleTagDashboard.vue?vue&type=template&id=ed63f6a0&scoped=true&"
import script from "./CreateSingleTagDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateSingleTagDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSingleTagDashboard.vue?vue&type=style&index=0&id=ed63f6a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed63f6a0",
  null
  
)

export default component.exports